// Routes owned by the VCard module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const vCardPaths = {
    vcardList: '/account/vcards',
    vcardCreatePage: '/account/vcards/new',
    vcardEditPage: '/account/vcards/:id/edit',
} as const
